var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 2.92498L7.9251 4.99998H5.0001V7.92498L2.9251 9.99998L5.0001 12.075V15H7.9251L10.0001 17.075L12.5001 14.575L16.7001 16.7L14.5501 12.525L17.0751 9.99998L15.0001 7.92498V4.99998H12.0751L10.0001 2.92498ZM10.0001 0.0999756L12.9001 2.99998H17.0001V7.09998L19.9001 9.99998L17.0001 12.9L19.8751 18.55C19.9918 18.7666 20.0251 18.9791 19.9751 19.1875C19.9251 19.3958 19.8334 19.5666 19.7001 19.7C19.5668 19.8333 19.3959 19.925 19.1876 19.975C18.9793 20.025 18.7668 19.9916 18.5501 19.875L12.9001 17L10.0001 19.9L7.1001 17H3.0001V12.9L0.100098 9.99998L3.0001 7.09998V2.99998H7.1001L10.0001 0.0999756Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBubble);
export default __webpack_public_path__ + "static/media/info_bubble.50a93b0f134c753a1bceb1bcfaa93e64.svg";
export { ForwardRef as ReactComponent };